export const ASK_AI_OPEN_EVENT = 'ask-ai:open';

export type AskAiOpenReason = 'session_ready' | 'guide_event' | 'agent_event' | 'chat_link' | 'unknown';

export const ASK_AI_USER_ACTION_EVENT = 'maddox:user_action';

export const ASK_AI_AUDIENCE_EVENT = 'ask-ai:audience';

export const ASK_AI_SET_AUDIENCE_EVENT = 'ask-ai:set-audience';

export type AskAiUserActionEventType = 'model_setup_discarded';

export type AskAiAudience = 'internal' | 'external';

export interface AskAiAudienceState {
  mode: AskAiAudience;
  canOverride: boolean;
}

export function emitAskAiUserAction(eventType: AskAiUserActionEventType, eventLabel?: string): void {
  window.dispatchEvent(new CustomEvent(ASK_AI_USER_ACTION_EVENT, {detail: {eventType, eventLabel}}));
}
